// REACT IMPORT: Core React library for functional component
import React from "react"
import { Link } from "react-router-dom"

// STYLING: Now using Tailwind CSS classes instead of traditional CSS
// All footer styling has been converted to Tailwind utility classes

// FOOTER COMPONENT: Legal links, copyright information, and app version
export const Footer = () => {
  return (
    <footer className="bg-white px-6 py-6">
      <div className="relative flex flex-col items-center gap-4 text-center text-sm font-semibold md:min-h-8 md:flex-row md:justify-between md:text-base">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-brand md:justify-start md:whitespace-nowrap">
          <Link to="/terms" className="transition-colors duration-200 hover:text-black">
            Terms and Conditions
          </Link>
          <Link to="/privacy" className="transition-colors duration-200 hover:text-black">
            Privacy Policy
          </Link>
        </div>

        <p className="text-black md:absolute md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:whitespace-nowrap">
          © 2026 <span className="text-brand">It's Yummtime.</span> All Rights Reserved
        </p>

        <div className="flex items-center gap-4 md:whitespace-nowrap md:text-right">
          <Link to="/support" className="text-brand transition-colors duration-200 hover:text-black">
            Support
          </Link>
          <p className="text-black">v0.1</p>
        </div>
      </div>
    </footer>
  )
}
